/* Landing cerobrasier — JS extraído de la fuente.
   Lo carga layout/landing.liquid (case 'cerobrasier'). */


(function(){
  /* ---- Precios: los combos cuadran con los descuentos genéricos de la tienda (Combo 2 unidades −29.900 · Combo 3 unidades −69.800).
     Sin tachado (estándar de landing A7): solo se muestra el ahorro real frente a comprar sueltos. ---- */
  var P={1:119900,2:209900,3:289900}, SUELTO=119900;
  /* ---- Variantes (Danny, 2026-10-19): 2 colores y 3 tallas. v = texto EXACTO de la opción en Shopify/Dropi. [PENDIENTE: confirmar] ---- */
  var TALLAS=['S','M','L'];
  var VAR={'S':'S','M':'M','L':'L'};
  var COLORES={
    negro:{n:'Negro',v:'Negro',pk:__A('ad-assets/09-packshot.jpg'),svg:__A('ad-assets/vestido.svg'),hero:__A('ad-assets/01-hero.jpg'),ok:false},
    blanco:{n:'Blanco',v:'Blanco',pk:__A('ad-assets/09-packshot-blanco.jpg'),svg:__A('ad-assets/vestido-blanco.svg'),hero:__A('ad-assets/01-hero-blanco.jpg'),ok:false}
  };
  var ORDEN_C=['negro','blanco'];
  /* ---- PEDIDO: un solo producto con variantes color × talla. Con 2 o 3 vestidos se pueden mezclar colores y tallas, así que el
     pedido se arma en el carrito interno de Releasit con una línea por variante (references/combo-multiproducto-releasit.md).
     Los descuentos automáticos "Combo N unidades" cuentan unidades de cualquier variante: mezclar no cambia el precio. ---- */
  var SHOP={handle:'vestido-escultura'};
  function shopCfg(){return window.__CEROBRASIER_SHOP||SHOP}   // la FASE 5 puede inyectarlo desde Liquid
  var GALERIA=[
    {src:__A('ad-assets/01-hero.jpg'),fb:__A('ad-assets/vestido.svg'),t:'Foto principal: mujer con el vestido junto a una ventana, luz de mañana'},
    {src:__A('ad-assets/02-perfil.jpg'),t:'De perfil: abdomen plano, cintura marcada y cola levantada'},
    {src:__A('ad-assets/03-interior.jpg'),t:'Por dentro: brasier con copas, body moldeador y short levanta cola'},
    {src:__A('ad-assets/04-espalda.jpg'),t:'De espalda: sin tiras de brasier ni bordes de faja'},
    {src:__A('ad-assets/01-hero-blanco.jpg'),fb:__A('ad-assets/vestido-blanco.svg'),t:'En blanco: la misma mujer con el vestido blanco junto a la ventana'}
  ];
  var qty=2, talla=null, tallas=[null,null,null], color='negro', colores=['negro','negro','negro'];
  var $=function(s,c){return (c||document).querySelector(s)}, $$=function(s,c){return Array.prototype.slice.call((c||document).querySelectorAll(s))};
  var fmt=function(n){return '$'+Math.round(n).toLocaleString('es-CO')};
  var A=function(p){return window.__A?window.__A(p):p};   // en Shopify los assets viven planos: __A lo define la section

  /* foto de cada color: la ilustración SVG hasta que cargue el packshot real (estándar A3) */
  function sw(k){var c=COLORES[k];return A(c.ok?c.pk:c.svg)}
  ORDEN_C.forEach(function(k){var im=new Image();im.onload=function(){COLORES[k].ok=true;renderColors();renderMix();refresh()};im.src=A(COLORES[k].pk)});

  /* galería */
  var main=$('#cb-main'), mainImg=$('#cb-main-img');
  $('#cb-thumbs').innerHTML=GALERIA.map(function(g,i){
    return '<button type="button" class="cb-th'+(i===0?' on':'')+'" data-i="'+i+'" aria-label="Foto '+(i+1)+'"><span class="cb-ph" data-n="'+(i+1)+'" style="display:block"><img src="'+A(g.src)+'" alt="" loading="lazy" onerror="this.parentNode.classList.add(\'cb-miss\')"></span></button>';
  }).join('');
  $('#cb-thumbs').addEventListener('click',function(e){
    var b=e.target.closest('.cb-th');if(!b)return;
    var g=GALERIA[+b.dataset.i];
    $$('.cb-th').forEach(function(x){x.classList.toggle('on',x===b)});
    main.classList.remove('cb-miss','cb-svgfb');main.setAttribute('data-shot',g.t);
    mainImg.onerror=function(){
      if(g.fb){mainImg.onerror=function(){mainImg.onerror=null;main.classList.add('cb-miss')};main.classList.add('cb-svgfb');mainImg.src=A(g.fb)}
      else{mainImg.onerror=null;main.classList.add('cb-miss')}
    };
    mainImg.src=A(g.src);
  });

  /* colores */
  function renderColors(){
    $('#cb-colors').innerHTML=ORDEN_C.map(function(k){return '<button type="button" class="cb-col'+(k===color?' on':'')+'" data-c="'+k+'" role="radio" aria-checked="'+(k===color)+'"><img src="'+sw(k)+'" alt="Vestido Escultura '+COLORES[k].n.toLowerCase()+'"><span>'+COLORES[k].n+'</span></button>'}).join('');
    $('#cb-color-n').textContent=COLORES[color].n;
  }
  function setColor(k){
    color=k;colores=[k,k,k];renderColors();renderMix();refresh();
    var i=k==='blanco'?4:0, b=$$('.cb-th')[i];if(b)b.click();   // muestra la foto de ese color
  }
  $('#cb-colors').addEventListener('click',function(e){var b=e.target.closest('.cb-col');if(b)setColor(b.dataset.c)});

  /* tallas */
  function chips(sel,cls){return TALLAS.map(function(t){return '<button type="button" class="cb-sz'+(cls||'')+(t===sel?' on':'')+'" data-t="'+t+'" role="radio" aria-checked="'+(t===sel)+'">'+t+'</button>'}).join('')}
  function renderSizes(){$('#cb-sizes').innerHTML=chips(talla)}
  function renderMix(){
    var box=$('#cb-mix');box.hidden=qty<2;if(qty<2)return;
    var h='';for(var i=0;i<qty;i++)h+='<div class="cb-mix-row" data-i="'+i+'"><span>Vestido '+(i+1)+'</span><div class="cb-mc">'+
      ORDEN_C.map(function(k){return '<button type="button" class="'+(colores[i]===k?'on':'')+'" data-c="'+k+'" aria-label="'+COLORES[k].n+'"><img src="'+sw(k)+'" alt=""></button>'}).join('')+
      '</div><div class="cb-ms">'+chips(tallas[i])+'</div></div>';
    $('#cb-mix-rows').innerHTML=h;
  }
  function setTalla(t){talla=t;tallas=[t,t,t];$('#cb-sizes').classList.remove('cb-need');$('#cb-need-msg').classList.remove('show');renderSizes();renderMix();refresh()}
  $('#cb-sizes').addEventListener('click',function(e){var b=e.target.closest('.cb-sz');if(b)setTalla(b.dataset.t)});
  $('#cb-mix-rows').addEventListener('click',function(e){
    var row=e.target.closest('.cb-mix-row');if(!row)return;
    var i=+row.dataset.i, b=e.target.closest('.cb-sz'), c=e.target.closest('.cb-mc button');
    if(b){tallas[i]=b.dataset.t;if(i===0){talla=b.dataset.t;renderSizes()}}
    else if(c){colores[i]=c.dataset.c;if(i===0){color=c.dataset.c;renderColors()}}
    else return;
    renderMix();refresh();
  });
  window.__needSize=function(el){
    el=el||$('#cb-sizes');el.scrollIntoView({behavior:'smooth',block:'center'});
    el.classList.remove('cb-need');void el.offsetWidth;el.classList.add('cb-need');$('#cb-need-msg').classList.add('show');
  };

  /* combos */
  function setQty(q){
    qty=q;$$('.cb-bundle').forEach(function(b){b.classList.toggle('on',+b.dataset.qty===q)});
    if(talla)for(var i=0;i<3;i++)if(!tallas[i])tallas[i]=talla;
    renderMix();refresh();
  }
  $('#cb-bundles').addEventListener('click',function(e){var b=e.target.closest('.cb-bundle');if(b)setQty(+b.dataset.qty)});

  function nombreColores(){
    var u=[];colores.slice(0,qty).forEach(function(k){if(u.indexOf(k)<0)u.push(k)});
    return u.map(function(k){return COLORES[k].n}).join(' + ');
  }
  function nombreTallas(){
    if(!talla)return 'Elige tu talla';
    var u=[];tallas.slice(0,qty).forEach(function(t){if(t&&u.indexOf(t)<0)u.push(t)});
    return (u.length>1?'Tallas ':'Talla ')+u.join(' + ');
  }
  function refresh(){
    var lab=qty+(qty>1?' vestidos':' vestido');
    $('#cb-st-t').textContent=lab+' · '+nombreColores()+' · '+nombreTallas();
    $('#cb-st-img').src=sw(colores[0]);
    $$('.cb-bundle').forEach(function(b){$$('.cb-b-img img',b).forEach(function(im,i){im.src=sw(+b.dataset.qty===qty?colores[i]:color)})});
    $('#cb-st-price').textContent=fmt(P[qty]);
    $('#cb-final-label').textContent=lab+' · '+nombreColores()+(talla?' · '+nombreTallas():'');
    $('#cb-final-price').textContent=fmt(P[qty]);
  }

  /* ---- CONTRATO SHOPIFY: un solo punto de compra ---- */
  function openOrder(btn){
    var q=btn&&btn.dataset.forceQty?+btn.dataset.forceQty:qty;
    if(q!==qty)setQty(q);
    var ts=tallas.slice(0,qty);
    if(!talla||ts.some(function(t){return !t})){window.__needSize($('#cb-sizes'));return}
    var cs=colores.slice(0,qty);
    window.__cerobrasier_SEL={qty:qty,color:COLORES[cs[0]].v,colores:cs.map(function(k){return COLORES[k].v}),size:VAR[ts[0]],sizes:ts.map(function(t){return VAR[t]})};
    try{localStorage.setItem('te_regalo','cerobrasier|'+Date.now())}catch(e){}
    if(rsiCOD(window.__cerobrasier_SEL))return;                                         // tienda: Releasit en la landing
    if(window.cerobrasierTriggerCOD&&window.cerobrasierTriggerCOD()!==false)return;      // respaldo de la fábrica
    abrirModalLocal();                                                                  // vista previa local
  }
  function findVar(prod,col,t){t=String(t).toUpperCase();col=String(col||'').toUpperCase();
    var tieneColor=(prod.options||[]).some(function(o){return /color/i.test(o.name||o)});
    return (prod.variants||[]).filter(function(v){
      var o=[v.option1,v.option2,v.option3].map(function(x){return String(x||'').toUpperCase()});
      return o.indexOf(t)>=0&&(!tieneColor||o.indexOf(col)>=0)})[0]}
  function espera(ms){return new Promise(function(r){setTimeout(r,ms)})}
  function avisoCargando(on){
    var t=document.getElementById('cb-wait');
    if(!t){t=document.createElement('div');t.id='cb-wait';t.textContent='Preparando tu pedido…';
      t.style.cssText='position:fixed;left:50%;bottom:140px;transform:translateX(-50%);z-index:2147483000;background:#141414;color:#FAF8F5;font:500 14px/1.2 Archivo,sans-serif;letter-spacing:.06em;padding:13px 22px;box-shadow:0 6px 24px rgba(0,0,0,.25);transition:opacity .3s;pointer-events:none';
      document.body.appendChild(t)}
    t.style.opacity=on?'1':'0';
  }
  function errorPedido(){
    avisoCargando(false);
    $('#cb-modal-body').innerHTML='<p style="padding:8px 0">No pudimos preparar tu pedido en este momento. Revisa tu conexión e inténtalo de nuevo.</p>';
    $('#cb-modal').classList.add('show');
  }
  async function listoReleasit(){
    for(var i=0;i<80;i++){
      try{var R=window._rsiV2,st=R&&R.getState&&R.getState();
        if(R&&R.cartService&&st&&st.loadingState&&!st.loadingState.isLoading)return R}catch(e){}
      await espera(100);
    }
    throw new Error('Releasit no cargó');
  }
  /* las 3 guías PDF también se ven dentro del formulario de Releasit */
  var REG_CSS='#cb-rsi-regalos{margin:10px 0 4px;padding:10px 12px;border:1.5px dashed #B8704F;background:#F1EBE3;color:#141414;line-height:1.3}'+
    '#cb-rsi-regalos .t{font-weight:700;font-size:14px;margin:0 0 6px}'+
    '#cb-rsi-regalos .r{display:flex;align-items:center;gap:8px;font-size:13px;margin:5px 0}'+
    '#cb-rsi-regalos img{width:30px;height:30px;flex:0 0 auto;background:#fff}'+
    '#cb-rsi-regalos .r span{flex:1}#cb-rsi-regalos b{color:#2F6B4A;font-size:12px;font-weight:800;letter-spacing:.06em}'+
    '#cb-rsi-regalos .n{font-size:11.5px;color:#6B655E;margin:6px 0 0}';
  function regalosForm(){
    var f=document.getElementById('rsi_form_wrapper');if(!f)return;
    var it=f.querySelector('.rsi-product-item-wrapper'),anc=it&&it.closest('.rsi-product-details-wrapper');
    var box=document.getElementById('cb-rsi-regalos');
    if(!anc){if(box)box.remove();return}
    if(!box){box=document.createElement('div');box.id='cb-rsi-regalos';
      box.innerHTML='<p class="t">🎁 Con tu pedido te llevas GRATIS</p>'+
        [[__A('ad-assets/regalo-talla.svg'),'Guía "Tu Talla Exacta en 2 Minutos"'],[__A('ad-assets/regalo-looks.svg'),'Guía "1 Vestido, 15 Looks"'],[__A('ad-assets/regalo-cuidado.svg'),'Guía "Cuidado de tu Vestido con Faja"']]
        .map(function(x){return '<div class="r"><img src="'+A(x[0])+'" alt=""><span>'+x[1]+'</span><b>GRATIS</b></div>'}).join('')+
        '<p class="n">Las guías se descargan apenas confirmes tu pedido.</p>'}
    if(box.parentNode!==anc.parentNode||box.previousElementSibling!==anc)anc.parentNode.insertBefore(box,anc.nextSibling);
  }
  var obs=null,obsEl=null;
  function vigilarForm(){
    if(!document.getElementById('cb-reg-css')){var c=document.createElement('style');c.id='cb-reg-css';c.textContent=REG_CSS;document.head.appendChild(c)}
    var t0=Date.now();
    (function busca(){
      var f=document.getElementById('rsi_form_wrapper');
      if(f&&f!==obsEl){if(obs)obs.disconnect();obsEl=f;var pend=0;
        obs=new MutationObserver(function(){if(!pend){pend=1;setTimeout(function(){pend=0;regalosForm()},16)}});
        obs.observe(f,{childList:true,subtree:true})}
      regalosForm();
      if(!f&&Date.now()-t0<6000)setTimeout(busca,150);
    })();
  }
  function rsiCOD(s){
    var C=shopCfg();
    if(!(window.Shopify&&C.handle))return false;
    avisoCargando(true);
    (async function(){
      var prod=await fetch('/products/'+C.handle+'.js',{headers:{Accept:'application/json'}}).then(function(r){return r.json()});
      var gid=function(v){return 'gid://shopify/ProductVariant/'+v.id};
      // una línea por talla; las tallas repetidas van en una sola línea con su cantidad
      var lines=[],idx={};
      for(var x=0;x<s.qty;x++){var v=findVar(prod,s.colores[x],s.sizes[x]);if(!v)throw new Error('variante no encontrada: '+s.colores[x]+' / '+s.sizes[x]);
        var m=gid(v);if(m in idx)lines[idx[m]].quantity++;else{idx[m]=lines.length;lines.push({merchandiseId:m,quantity:1})}}
      var R=await listoReleasit(), cs=R.cartService;
      R.setState({isOpen:false});
      var st=R.getState(), S=window._RSI_COD_FORM_SETTINGS;
      // 'producto + carrito' SOLO en esta página y en esta visita (si no, Releasit agrega además la variante por defecto)
      if(S&&S.productPage)S.productPage.addMode='product-plus-cart';
      R.setState({productPage:Object.assign({},st.productPage,{addMode:'product-plus-cart'})});
      var id=st.cartInfo&&st.cartInfo.id;
      if(!id){var g0=await cs.getCart();id=g0.data.cart.id;R.setState({cartInfo:g0.data.cart})}
      await cs.clearCart(id);
      await cs.addProduct(id,lines);
      R.setState({isOpen:true});
      R.setState({triggerCartUpdate:1});
      vigilarForm();
      // verificación + autocorrección: el carrito de Releasit debe quedar con EXACTAMENTE estas líneas
      var want={};lines.forEach(function(l){want[l.merchandiseId]=l.quantity});
      var ok=false;
      for(var k=0;k<4&&!ok;k++){
        await espera(k?700:1200);
        var cid=R.getState().cartInfo.id, g=await cs.getCart(cid), edges=g.data.cart.lines.edges||[];
        var sobran=[],corregir=[],vistos={};
        edges.forEach(function(e){var mm=e.node.merchandise.id;
          if(!(mm in want)||vistos[mm])sobran.push(e.node.id);
          else{vistos[mm]=1;if(e.node.quantity!==want[mm])corregir.push({id:e.node.id,quantity:want[mm]})}});
        var faltan=lines.filter(function(l){return !vistos[l.merchandiseId]});
        ok=!sobran.length&&!corregir.length&&!faltan.length;
        if(!ok){
          if(sobran.length)await cs.removeProduct(cid,sobran);
          if(corregir.length)await cs.updateProduct(cid,corregir);
          if(faltan.length)await cs.addProduct(cid,faltan);
          R.setState({triggerCartUpdate:1});
        }
      }
      if(!ok){R.setState({isOpen:false});throw new Error('el carrito de Releasit no cuadró tras corregir')}
      avisoCargando(false);
    })().catch(function(e){
      console.warn('[cerobrasier] pedido:',e);
      avisoCargando(false);
      var iguales=s.sizes.every(function(t,i){return t===s.sizes[0]&&s.colores[i]===s.colores[0]});
      if(iguales&&window.cerobrasierTriggerCOD&&window.cerobrasierTriggerCOD()!==false)return;   // misma talla: flujo normal de Releasit
      errorPedido();
    });
    return true;
  }
  function abrirModalLocal(){
    var s=window.__cerobrasier_SEL;
    var rows=[['Producto','Vestido Escultura'],['Cantidad',s.qty+(s.qty>1?' vestidos':' vestido')],['Color'+(s.qty>1?'es':''),s.colores.join(' · ')],['Talla'+(s.qty>1?'s':''),s.sizes.join(' · ')],['3 guías PDF','🎁 GRATIS'],['Total',fmt(P[s.qty])],['Pago','Contra entrega, en efectivo']];
    $('#cb-modal-body').innerHTML=rows.map(function(r){return '<div class="cb-modal-row"><span>'+r[0]+'</span><span>'+r[1]+'</span></div>'}).join('');
    $('#cb-modal').classList.add('show');
  }
  $$('[data-order]').forEach(function(b){b.addEventListener('click',function(){openOrder(b)})});
  $$('[data-sg]').forEach(function(b){b.addEventListener('click',function(){$('#cb-sg').classList.add('show')})});
  $$('.cb-modal').forEach(function(m){m.addEventListener('click',function(e){if(e.target===m||e.target.closest('[data-close]'))m.classList.remove('show')})});

  /* barra siempre a la vista (estándar A2): solo se esconde con el formulario de Releasit abierto (CSS de abajo) */
  $('#cb-sticky').classList.add('show');
  $('#cb-st-gifts').onclick=function(){$('#cb-gifts').scrollIntoView({behavior:'smooth',block:'center'})};

  /* formulario de Releasit con la marca de la landing (estándar A6) */
  (function(){
    var css='#rsi_form_wrapper .rsi-submit_button{background:#141414!important;border:0!important;border-radius:0!important;box-shadow:0 10px 24px rgba(20,20,20,.22)!important;color:#FAF8F5!important}'+
      '#rsi_form_wrapper .rsi-submit_button .rsi-custom-button-content{font-family:Archivo,Inter,sans-serif!important;font-size:15px!important;font-weight:600!important;letter-spacing:.06em!important;line-height:1.25!important;text-transform:uppercase!important;color:#FAF8F5!important}'+
      '#rsi_form_wrapper .rsi-submit_button .rsi-icon{color:#D9B8A4!important}'+
      '#rsi_form_wrapper .rsi-submit_button:hover{filter:brightness(1.3)}'+
      '#rsi_form_wrapper .rsi-form-header,#rsi_form_wrapper .rsi-form-header *,#rsi_form_wrapper .rsi-form-close-button{color:#141414!important}'+
      '#rsi_form_wrapper .rsi-shipping-rates-item{border-color:#141414!important}'+
      'body:has(#rsi_form_wrapper[open]) .cb-sticky,body:has(#rsi_form_wrapper[open]) .cb-ann{visibility:hidden!important}';
    var st=document.createElement('style');st.id='cerobrasier-rsi-css';st.textContent=css;document.head.appendChild(st);
  })();

  renderColors();renderSizes();renderMix();refresh();
})();

/* ============================================================
   Releasit COD — variante activa + cantidad + disparo del modal
   Lo genera tools/apply_cod_trigger.py desde tools/cod_trigger.js.tpl.

   PATRÓN:
   NO se crean variantes-bundle. Dropi solo despacha las variantes que
   mapeó al IMPORTAR el producto; una variante creada después por API
   queda huérfana y el pedido no le llega (bug real de producción).
   Por eso el bundle es la MISMA variante de Dropi con quantity = N, y el
   total lo baja un descuento automático de Shopify (mín. N unidades).
   Así el pedido lleva las unidades físicas reales y Dropi las despacha.

   Releasit lee la cantidad de input[name="quantity"] en el DOM al abrir,
   y la variante de window.productData — pero SOLO la re-lee si se hace
   click en su botón nativo. _rsiV2.setState abre el modal con la variante
   cacheada al init, así que queda como último recurso.
   Depende de quantityControlsHidden:true en Releasit (ya global): si el
   cliente pudiera bajar la cantidad, pagaría el precio con descuento por
   menos unidades.
   ============================================================ */
(function () {
  var RELEASIT_SELECTORS = [
    '#rsi_buy_now_button',
    '.rsi_buy_now_button',
    '._rsi-buy-now-button',
    '._rsi-buy-now-button-app-block-hook button',
    '._rsi-buy-now-button-app-block-hook a',
    '.rsi-btn-skel'
  ];

  function findReleasitButton() {
    for (var i = 0; i < RELEASIT_SELECTORS.length; i++) {
      var el = document.querySelector(RELEASIT_SELECTORS[i]);
      if (el) return el;
    }
    return null;
  }

  function setVariantOnAllForms(variantId, qty) {
    if (!variantId) return;
    var q = parseInt(qty, 10);
    if (!q || q < 1) q = 1;
    document.querySelectorAll('form[action="/cart/add"] input[name="id"]').forEach(function (i) {
      i.value = variantId;
      i.setAttribute('value', variantId);
    });
    document.querySelectorAll('input[name="product-id"]').forEach(function (i) { i.value = variantId; });
    document.querySelectorAll('input[name="quantity"]').forEach(function (i) {
      i.value = String(q);
      i.setAttribute('value', String(q));
    });
    if (window.productData) { window.productData.quantity = q; }
    if (window.productData && Array.isArray(window.productData.variants)) {
      var v = window.productData.variants.find(function (x) { return String(x.id) === String(variantId); });
      if (v) {
        window.productData.selected_or_first_available_variant = v;
        window.productData.selected_variant = v;
        try {
          document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: v } }));
          document.dispatchEvent(new CustomEvent('product:variant-change', { detail: { variant: v } }));
        } catch (e) {}
      }
    }
  }

  /* Qué variante y qué cantidad está eligiendo el cliente ahora mismo.
     Siempre se lee del DOM — nunca del SKU, que Dropi reescribe. */
  function qtyOf(s) {
    var q = parseInt(s && s.qty, 10);
    if (!q) { var on = document.querySelector('[data-qty].on, [data-qty].active, [data-qty][aria-checked="true"]');
      q = on ? parseInt(on.getAttribute('data-qty'), 10) : 1; }
    return q || 1;
  }
  function current() {
    var s = window.__cerobrasier_SEL || {};
    var V = window.CEROBRASIER_VARIANTS || [];
    var n = function (x) { return String(x || '').toLowerCase().normalize('NFD')
      .replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]/g, ''); };
    var v = V.filter(function (x) {
      return n(x.color) === n(s.color) && (s.size == null || String(x.talla) === String(s.size));
    })[0];
    return v ? { id: v.id, qty: qtyOf(s) } : null;
  }

  function sync() {
    var s = current();
    if (s && s.id) setVariantOnAllForms(s.id, s.qty);
    return s;
  }

  // el JS de la landing ya mueve la clase activa; aquí solo re-leemos después
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('.__cerobrasier-no-watch')) {
      setTimeout(sync, 0);
    }
  }, true);

  document.addEventListener('DOMContentLoaded', sync);
  sync();

  window.cerobrasierTriggerCOD = function () {
    var s = sync();
    if (!s || !s.id) return;
    setTimeout(function () {
      var b0 = findReleasitButton();
      if (b0) { b0.click(); return; }
      var attempts = 0;
      var poll = setInterval(function () {
        attempts++;
        var b = findReleasitButton();
        if (b) { clearInterval(poll); b.click(); return; }
        if (attempts > 30) {
          clearInterval(poll);
          if (window._rsiV2 && typeof window._rsiV2.setState === 'function') {
            try { window._rsiV2.setState({ isOpen: true }); } catch (e) {}
          }
        }
      }, 100);
    }, 50);
  };
})();
